import { Pipe, PipeTransform } from "@angular/core";
import { EstudioDTO } from "@DTOS";
import { obtenerNombreEstado } from "@shared/enums";

@Pipe({
    name: "nombreEstadoEstudio"
})
export class NombreEstadoEstudioPipe implements PipeTransform {

    transform(estudio: EstudioDTO): string {
        return obtenerNombreEstado(estudio.estado);
    }

}
